import type { BottleType } from "../schema";
import { INK, centred, doc, hairline, imageSlot, labelWidth, rect } from "./kit";
import type { LabelTemplate } from "./types";

// Framed mark: the visitor's logo inside a double gold rule on black. The
// frame hugs the label edge (as the château does), so each bottle gets its
// own layout; the slot is the first element (the back of the stack), and the
// frames are unfilled, so they never cover the logo and taps reach the slot.
export const logoFramedDark: LabelTemplate = {
  key: "logo-framed-dark",
  name: "Framed mark",
  occasion: "corporate",
  style: "Logo in a gold frame on black",
  description: "Your logo in a double gold frame on black — send a light version of your logo.",
  hasImageSlot: true,
  slot: "logo",
  build(bottle: BottleType) {
    const W = labelWidth(bottle);
    const cx = W / 2;
    return doc(bottle, INK.black, [
      imageSlot({ x: cx - 20, y: 14, width: 40, height: 24 }, "Add your logo"),
      rect(INK.gold, { x: 3, y: 3, width: W - 6, height: 94 }, 0.4),
      rect(INK.gold, { x: 5, y: 5, width: W - 10, height: 90 }, 0.3),
      hairline(INK.gold, cx, 44, 30),
      // Tracked Cinzel capitals run 69 mm at 4.5 mm; the MCC frame is 70 mm inside, so a size down there.
      centred(bottle, { text: "YOUR COMPANY", font: "cinzel", size: bottle === "wine" ? 4.5 : 4, color: INK.gold, baseline: 54, tracking: 0.2 }),
      centred(bottle, { text: "With our thanks · 2026", font: "cormorant", italic: true, size: 2.8, color: INK.gold, baseline: 61, tracking: 0.02 }),
      centred(bottle, { text: "Private Cellar", font: "montserrat", size: 1.8, color: INK.gold, baseline: 88, tracking: 0.25 }),
    ]);
  },
};
